/**
 *
 * FeatureConfiguration
 *
 */

import React, { memo, useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';
import {
  Space,
  Text,
  Button,
  Paper,
  Toggle,
  Popup,
  Icon,
  AlertModal,
  Conditional,
} from '@cashfree-intl/coherent';

import { useInjectSaga } from 'utils/injectSaga';
import { useInjectReducer } from 'utils/injectReducer';
import { ON_DEMAND_SETTLEMENT_STATUS_MAPPER } from 'utils/constants';

// import InputWithCounter from 'components/InputWithCounter';
import Loader from 'components/Loader';

import makeSelectFeatureConfiguration from './selectors';
import reducer from './reducer';
import saga from './saga';

import {
  // ADD,
  // SUBTRACT,
  NOT_REQUESTED,
  IN_REVIEW,
  ACTIVE,
  REJECTED,
  DISABLED,
  DEFAULT_PAYLOAD,
  // ORDER_SPLIT_DELAY_MAX_VALUE,
  // DEFER_SETTLEMENT_MAX_VALUE,
  SETTLEMENTS_CYCLE_OPTIONS,
  KNOW_MORE_LINKS,
  DEFAULT_MAX_DELAY_VALUE,
} from './constants';

import {
  fetchSettlementConfigAction,
  enableLoaderAction,
  updateEasySplitConfigAction,
  requestOnDemandActivationAction,
} from './actions';

import { MerchantContext } from '../../contexts/MerchantContext';

export function FeatureConfiguration({
  fetchSettlementConfig,
  enableLoader,
  updateEasySplitConfig,
  requestOnDemandActivation,
  featureConfiguration: { isLoading },
}) {
  useInjectReducer({ key: 'featureConfiguration', reducer });
  useInjectSaga({ key: 'featureConfiguration', saga });

  const { easySplitEnabled } = useContext(MerchantContext);

  const [config, setConfig] = useState({
    VENDOR_DASHBOARD_ACCESS: false,
    ORDER_SPLIT_DELAY: false,
    DEFER_SETTLEMENT: false,
    ON_DEMAND_SETTLEMENT: false,
    INSTANT_SETTLEMENT: false,
    VENDOR_SETTLEMENT_CYCLE: false,
  });
  const [requestConfirmation, setRequestConfirmation] = useState(false);
  const [orderSplitDelay, setOrderSplitDelay] = useState(
    DEFAULT_MAX_DELAY_VALUE,
  );
  const [deferSettlement, setDeferSettlement] = useState(
    DEFAULT_MAX_DELAY_VALUE,
  );
  const [splitConfigData, setSplitConfigData] = useState({});
  const [availableSchedules, setAvailableSchedules] = useState({});
  const [onDemandSettlementStatus, setOnDemandSettlementStatus] = useState(
    NOT_REQUESTED,
  );

  const handleToggle = key => () => {
    if (
      [
        'ORDER_SPLIT_DELAY',
        'DEFER_SETTLEMENT',
        'ON_DEMAND_SETTLEMENT',
      ].includes(key)
    ) {
      const resultant = { ...splitConfigData };

      if (key === 'ORDER_SPLIT_DELAY') {
        resultant.orderSplitAfterPaymentEnabled = !config[key];
        if (
          !splitConfigData.orderSplitMaxDelayInDays ||
          splitConfigData.orderSplitMaxDelayInDays < 1
        ) {
          resultant.orderSplitMaxDelayInDays = DEFAULT_MAX_DELAY_VALUE;
          setOrderSplitDelay(DEFAULT_MAX_DELAY_VALUE);
        }
      } else if (key === 'DEFER_SETTLEMENT') {
        resultant.deferredSettlementEnabled = !config[key];
        if (
          !splitConfigData.maxDelayInDays ||
          splitConfigData.maxDelayInDays < 1
        ) {
          resultant.maxDelayInDays = DEFAULT_MAX_DELAY_VALUE;
          setDeferSettlement(DEFAULT_MAX_DELAY_VALUE);
        }
      } else resultant.onDemandEnabled = !config[key];

      enableLoader();

      updateEasySplitConfig({
        data: resultant,
        cb: () => {
          setSplitConfigData(resultant);
          setConfig(prev => ({ ...prev, [key]: !config[key] }));
        },
      });
    } else {
      setConfig(prev => ({ ...prev, [key]: !config[key] }));
    }
  };

  const onDemandActivation = () => {
    enableLoader();
    requestOnDemandActivation(response => {
      setOnDemandSettlementStatus(
        ON_DEMAND_SETTLEMENT_STATUS_MAPPER[response.status.toUpperCase()],
      );
      setRequestConfirmation(true);
    });
  };

  // const handleInputIconClick = key => () => {
  //   // console.log(key);
  //   if (
  //     (parseInt(orderSplitDelay || 0, 10) >= ORDER_SPLIT_DELAY_MAX_VALUE &&
  //       key === ADD) ||
  //     (parseInt(orderSplitDelay || 0, 10) <= 1 && key === SUBTRACT)
  //   )
  //     return;

  //   const result =
  //     key === ADD
  //       ? parseInt(Number(orderSplitDelay) || 0, 10) + 1
  //       : parseInt(Number(orderSplitDelay), 10) - 1;

  //   setOrderSplitDelay(result);
  // };

  // const handleDeferSettlementInputIconClick = key => () => {
  //   // console.log(key);
  //   if (
  //     (parseInt(deferSettlement || 0, 10) >= DEFER_SETTLEMENT_MAX_VALUE &&
  //       key === ADD) ||
  //     (parseInt(deferSettlement || 0, 10) <= 1 && key === SUBTRACT)
  //   )
  //     return;

  //   const result =
  //     key === ADD
  //       ? parseInt(Number(deferSettlement) || 0, 10) + 1
  //       : parseInt(Number(deferSettlement), 10) - 1;

  //   setDeferSettlement(result);
  // };

  // const handleOrderSplitDelayChange = (e, data) => {
  //   // console.log(data.value, Number(data.value));
  //   if (!Number.isNaN(parseInt(data.value, 10))) {
  //     setOrderSplitDelay(parseInt(data.value, 10));
  //   } else {
  //     setOrderSplitDelay(0);
  //   }
  // };

  // const handleDeferSettlementChange = (e, data) => {
  //   // console.log(data.value, Number(data.value));
  //   if (!Number.isNaN(parseInt(data.value, 10))) {
  //     setDeferSettlement(parseInt(data.value, 10));
  //   } else {
  //     setDeferSettlement(0);
  //   }
  // };

  // const onSaveChanges = key => () => {
  //   const resultant = { ...splitConfigData };

  //   if (key === 'ORDER_SPLIT_DELAY') {
  //     resultant.orderSplitMaxDelayInDays = orderSplitDelay;
  //   } else {
  //     resultant.maxDelayInDays = deferSettlement;
  //   }

  //   enableLoader();
  //   updateEasySplitConfig({
  //     data: resultant,
  //     cb: () => setSplitConfigData(resultant),
  //   });
  // };

  const updateBillingConfigurationData = ({
    splitConfig = {},
    splitVendorOptions = {},
    onDemandStatus = {},
  }) => {
    const configData = JSON.parse(JSON.stringify(splitConfig));

    const {
      deferredSettlementEnabled,
      maxDelayInDays,
      orderSplitAfterPaymentEnabled,
      onDemandEnabled,
      orderSplitMaxDelayInDays,
    } = configData;

    delete configData.addedOn;
    delete configData.updatedOn;

    if (onDemandStatus && onDemandStatus.status)
      setOnDemandSettlementStatus(
        ON_DEMAND_SETTLEMENT_STATUS_MAPPER[onDemandStatus.status.toUpperCase()],
      );
    else setOnDemandSettlementStatus(NOT_REQUESTED);

    setConfig({
      ...config,
      DEFER_SETTLEMENT: deferredSettlementEnabled,
      ORDER_SPLIT_DELAY: orderSplitAfterPaymentEnabled,
      ON_DEMAND_SETTLEMENT: onDemandEnabled,
    });

    setOrderSplitDelay(orderSplitMaxDelayInDays);
    setDeferSettlement(maxDelayInDays);
    setSplitConfigData({ ...configData, ...DEFAULT_PAYLOAD });
    setAvailableSchedules(splitVendorOptions.availableSchedules || {});
  };

  useEffect(() => {
    enableLoader();
    fetchSettlementConfig(updateBillingConfigurationData);
  }, []);

  const closeModal = () => setRequestConfirmation(false);

  // const isOrderSplitDelayValid = config.ORDER_SPLIT_DELAY
  //   ? orderSplitDelay >= 1 && orderSplitDelay <= ORDER_SPLIT_DELAY_MAX_VALUE
  //   : true;

  // const isDeferSettlementValid = config.DEFER_SETTLEMENT
  //   ? deferSettlement >= 1 && deferSettlement <= DEFER_SETTLEMENT_MAX_VALUE
  //   : true;

  return (
    <Conditional if={easySplitEnabled}>
      <div className="feature-config">
        <Loader active={isLoading} />
        <Space
          justifyContent="space-between"
          alignItems="center"
          className="mb-2"
        >
          <Text as="span" color="bodyLight">
            Configure dashboard access, settlement timelines, and more for the
            vendors.{' '}
            <a
              href={KNOW_MORE_LINKS.INTEGRATE_EASY_SPLIT}
              target="_blank"
              className="know-more-link"
            >
              Know more.
            </a>
          </Text>
        </Space>
        <div className="grid-two-columns">
          <Paper className="py-2 px-3 mt-2">
            <Space
              className="mb-2"
              justifyContent="space-between"
              alignItems="center"
            >
              <div>
                <Text variant="b14" className="mb-1">
                  Order Split Delay Post Successful Payment
                </Text>
                <Text variant="b14" color="bodyLight">
                  Delay the splitting of order amount to vendors by a defined
                  time.{' '}
                  <a
                    href={KNOW_MORE_LINKS.ORDER_SPLIT_DELAY}
                    target="_blank"
                    className="know-more-link"
                  >
                    Know more.
                  </a>
                </Text>
              </div>
              {/* <div className="feature-toggle">
                <Toggle
                  active={config.ORDER_SPLIT_DELAY}
                  onToggle={handleToggle('ORDER_SPLIT_DELAY')}
                />
              </div> */}
            </Space>
            <Space alignItems="center" gap={2} className="mb-2">
              <Text variant="b14" color="bodyLight">
                Delay by Days
              </Text>
              <Text>{orderSplitDelay}</Text>
            </Space>
            <Text color="bodyLight">
              To enable/update the preferences, kindly contact your account
              manager or write to us at{' '}
              <span className="w-700">care@cashfree.com</span>
            </Text>
            {/* This might be used later once we can solve the issue for capturing updatedBy */}
            {/* <InputWithCounter
              name="orderSplitDelay"
              value={orderSplitDelay}
              onChange={handleOrderSplitDelayChange}
              clss={`order-split-delay ${
                !config.ORDER_SPLIT_DELAY ? 'disabled' : ''
              }`}
              errorBorder={!isOrderSplitDelayValid}
              handleInputIconClick={handleInputIconClick}
              disabledSubtract={
                orderSplitDelay <= 1 || !config.ORDER_SPLIT_DELAY
              }
              disabledAdd={
                orderSplitDelay >= ORDER_SPLIT_DELAY_MAX_VALUE ||
                !config.ORDER_SPLIT_DELAY
              }
              error={!isOrderSplitDelayValid}
              errorMessage={`No. should be between 1 and ${ORDER_SPLIT_DELAY_MAX_VALUE}`}
            />
            <Button
              className="mt-1"
              primary
              disabled={!config.ORDER_SPLIT_DELAY}
              onClick={onSaveChanges('ORDER_SPLIT_DELAY')}
            >
              Save Changes
            </Button> */}
          </Paper>
          <Paper className="py-2 px-3 mt-2">
            <Space
              className="mb-2"
              justifyContent="space-between"
              alignItems="center"
            >
              <div>
                <Text variant="b14" className="mb-1">
                  Defer Settlement
                </Text>
                <Text variant="b14" color="bodyLight">
                  Add delay in settlements to vendor accounts basis business
                  service delivery time of vendors.{' '}
                  <a
                    href={KNOW_MORE_LINKS.DEFER_SETTLEMENT}
                    target="_blank"
                    className="know-more-link"
                  >
                    Know more.
                  </a>
                </Text>
              </div>
              {/* <div className="feature-toggle">
                <Toggle
                  active={config.DEFER_SETTLEMENT}
                  onToggle={handleToggle('DEFER_SETTLEMENT')}
                />
              </div> */}
            </Space>
            <Space alignItems="center" gap={2} className="mb-2">
              <Text variant="b14" color="bodyLight">
                Defer by Days
              </Text>
              <Text>{deferSettlement}</Text>
            </Space>
            <Text color="bodyLight">
              To enable/update the preferences, kindly contact your account
              manager or write to us at{' '}
              <span className="w-700">care@cashfree.com</span>
            </Text>
            {/* This might be used later once we can solve the issue for capturing updatedBy */}
            {/* <InputWithCounter
              name="deferSettlement"
              value={deferSettlement}
              onChange={handleDeferSettlementChange}
              clss={`defer-settlement ${
                !config.DEFER_SETTLEMENT ? 'disabled' : ''
              }`}
              errorBorder={!isDeferSettlementValid}
              handleInputIconClick={handleDeferSettlementInputIconClick}
              disabledSubtract={
                deferSettlement <= 1 || !config.DEFER_SETTLEMENT
              }
              disabledAdd={
                deferSettlement >= DEFER_SETTLEMENT_MAX_VALUE ||
                !config.DEFER_SETTLEMENT
              }
              error={!isDeferSettlementValid}
              errorMessage={`No. should be between 1 and ${DEFER_SETTLEMENT_MAX_VALUE}`}
            />
            <Button
              className="mt-1"
              primary
              disabled={!config.DEFER_SETTLEMENT}
              onClick={onSaveChanges('DEFER_SETTLEMENT')}
            >
              Save Changes
            </Button> */}
          </Paper>
        </div>
        <Paper className="py-2 px-3 my-2 pointer">
          <Space justifyContent="space-between" alignItems="center">
            <div>
              <Text variant="b14" className="mb-1">
                On Demand Settlement
              </Text>
              <Text variant="b14" color="bodyLight">
                Request settlements to vendor accounts any day, and at any time
                24*7, including holidays.{' '}
                <a
                  href={KNOW_MORE_LINKS.ON_DEMAND_SETTLEMENT}
                  target="_blank"
                  className="know-more-link"
                >
                  Know more.
                </a>
              </Text>
            </div>
            <Conditional if={onDemandSettlementStatus === NOT_REQUESTED}>
              <Button
                className="ui button violet-button-outline"
                onClick={onDemandActivation}
              >
                Request Activation
              </Button>
            </Conditional>
            <Conditional if={onDemandSettlementStatus === IN_REVIEW}>
              <Text variant="b14" color="warning">
                Activation Pending
              </Text>
            </Conditional>
            <Conditional if={onDemandSettlementStatus === REJECTED}>
              <Popup
                content="Your request for activation of On-Demand settlement has been rejected."
                trigger={
                  <Text variant="b14" className="w-500" color="danger">
                    Activation Failed
                  </Text>
                }
              />
            </Conditional>
            <Conditional
              if={[ACTIVE, DISABLED].includes(onDemandSettlementStatus)}
            >
              <Toggle
                active={splitConfigData.onDemandEnabled}
                onToggle={handleToggle('ON_DEMAND_SETTLEMENT')}
              />
            </Conditional>
          </Space>
        </Paper>
        <Paper className="py-2 px-3 my-2">
          <Text variant="b14" className="mb-1">
            Instant Settlement
          </Text>
          <Text variant="b14" color="bodyLight">
            All transactions will be settled based on T+0{' '}
            <a
              href={KNOW_MORE_LINKS.VENDOR_INSTANT_SETTLEMENT}
              target="_blank"
              className="know-more-link"
            >
              Know more.
            </a>
          </Text>
          <Space direction="column" gap={3} className="mt-3">
            {SETTLEMENTS_CYCLE_OPTIONS.INSTANT_SETTLEMENTS.map(obj => {
              // compute if cycle is active / not active
              const isActive = obj.key in availableSchedules;

              return (
                <Space
                  key={obj.key}
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Text variant="b14">{obj.text}</Text>
                  {isActive ? (
                    <Text variant="b14" color="success">
                      Active
                    </Text>
                  ) : (
                    <Popup
                      content="Please contact your account manager to get this activated"
                      trigger={
                        <Text
                          variant="b14"
                          className="w-500 pointer"
                          color="bodyLight"
                        >
                          Disabled
                        </Text>
                      }
                    />
                  )}
                </Space>
              );
            })}
          </Space>
        </Paper>
        <Paper
          className="py-2 px-3 my-2 pointer"
          onClick={handleToggle('VENDOR_SETTLEMENT_CYCLE')}
        >
          <Space justifyContent="space-between" alignItems="center">
            <div>
              <Text variant="b14" className="mb-1">
                Vendor Settlement Cycle
              </Text>
              <Text variant="b14" color="bodyLight">
                Active vendor settlement cycles for your account are shown
                below.
              </Text>
            </div>
            <Icon
              name={
                config.VENDOR_SETTLEMENT_CYCLE ? 'chevron-up' : 'chevron-down'
              }
              className="ml-1"
            />
          </Space>
          <Conditional if={config.VENDOR_SETTLEMENT_CYCLE}>
            <Space direction="column" gap={3} className="mt-3">
              {SETTLEMENTS_CYCLE_OPTIONS.VENDOR_SETTLEMENTS.map(obj => {
                // compute if cycle is active / not active
                const isActive = obj.key in availableSchedules;

                return isActive ? (
                  <Text variant="b14" key={obj.key}>
                    {obj.text}
                  </Text>
                ) : null;
              })}
            </Space>
          </Conditional>
        </Paper>
        {requestConfirmation && (
          <AlertModal
            className="p-4"
            type="success"
            title="Request Submitted Successfully"
            onClose={closeModal}
            eventNameOnClose="Request_Submitted_Successfully_Close"
          >
            <Text variant="b14" color="bodyLight" className="mt-1">
              Your request to activate{' '}
              <Text as="span" variant="b14" strong>
                On Demand Settlement{' '}
              </Text>
              has been submitted successfully. We will revert in 2 working days.
            </Text>

            <Text variant="b14" color="bodyLight" className="mt-1  mb-4">
              Contact your account manager or write to{' '}
              <a href="mailto:care@cashfree.com">care@cashfree.com</a> for any
              further queries.
            </Text>
          </AlertModal>
        )}
      </div>
    </Conditional>
  );
}

FeatureConfiguration.propTypes = {
  enableLoader: PropTypes.func.isRequired,
  fetchSettlementConfig: PropTypes.func.isRequired,
  updateEasySplitConfig: PropTypes.func.isRequired,
  featureConfiguration: PropTypes.object.isRequired,
  requestOnDemandActivation: PropTypes.func.isRequired,
};

const mapStateToProps = createStructuredSelector({
  featureConfiguration: makeSelectFeatureConfiguration(),
});

function mapDispatchToProps(dispatch) {
  return {
    fetchSettlementConfig: data => dispatch(fetchSettlementConfigAction(data)),
    enableLoader: () => dispatch(enableLoaderAction()),
    updateEasySplitConfig: data => dispatch(updateEasySplitConfigAction(data)),
    requestOnDemandActivation: data =>
      dispatch(requestOnDemandActivationAction(data)),
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withConnect,
  memo,
)(FeatureConfiguration);
